export default __webpack_public_path__ + "src/images/packages/shipwreck-lodge/3c7d37e33af31e9a47fd63fa3277c80c-3.jpeg";